import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  footer: {
    height: '14px',
    paddingLeft: 0,
    paddingRight: 0,
    fontFamily: Theme.typography.base.regular,
    marginTop: 20,
    flexShrink: 0,
    '& a': {
      fontFamily: Theme.typography.base.regular,
    },
    [Theme.breakpoints.up('md')]: {
      marginTop: 30,
    },
    [Theme.breakpoints.up('xl')]: {
      marginTop: 40,
    },
    '& .MuiTypography-root': {
      paddingLeft: '30px',
      [Theme.breakpoints.down('lg')]: {
        paddingLeft: '37px',
      },
      [Theme.breakpoints.down('md')]: {
        paddingLeft: '30px',
      },
      [Theme.breakpoints.down('sm')]: {
        paddingLeft: '20px',
      },
    },
  },
  footerContanier: {
    display: 'flex',
    maxWidth: '1080px',
    margin: '0 auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    justifyContent: 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    [Theme.breakpoints.up('sm')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [Theme.breakpoints.up('md')]: {
      paddingLeft: 50,
      paddingRight: 50,
    },
    [Theme.breakpoints.up('xl')]: {
      padding: 0,
    },
    '& a': {
      color: Theme.palette.primary.light,
      fontSize: Theme.typography.size[0],
    },
    '& .MuiBox-root': {
      paddingLeft: '0',
      '& .MuiTypography-root': {
        paddingLeft: '0',
        '& a:last-child': {
          paddingLeft: '24px',
          [Theme.breakpoints.up('md')]: {
            paddingLeft: '40px',
          },
        },
      },
    },
  },
  footerInfo: {
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[0],
    '&.MuiTypography-root': {
      paddingLeft: '0',
    },
  },
}));

export default useStyles;
